<template>
  <PageLayout title="Barevná paleta">
    <section v-for="(color, colorKey) in palette" :key="colorKey">
      <h2>{{ colorKey }}</h2>
      <v-row v-if="typeof color === 'object'">
        <v-col
          cols="4"
          md="2"
          v-for="(shade, shadeKey) in color"
          :key="shadeKey"
        >
          <ColorCard v-bind="{ color: shade, label: shadeKey }" />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="4" md="2">
          <ColorCard v-bind="{ color, label: colorKey }" />
        </v-col>
      </v-row>
    </section>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/design-system/PageLayout.vue"
import ColorCard from "@/components/page/design-system/ColorCard.vue"
import { palette } from "@/plugins/vuetify"

export default {
  components: {
    PageLayout,
    ColorCard,
  },
  data() {
    return { palette }
  },
}
</script>
